module.exports = __webpack_public_path__ + "img/bg_avatar_female_71.d6d4a545.png";